// extracted by mini-css-extract-plugin
module.exports = {"hashMenu":"styles-module--hashMenu--3CED0"};